import { isSupabaseConfigured, supabase } from './supabaseClient';

export async function fetchPublicStoreSettings() {
  if (!isSupabaseConfigured) {
    return {
      shipping_flat_rate: 0,
      shipping_free_threshold: null,
    };
  }

  const { data, error } = await supabase
    .from('store_settings')
    .select('shipping_flat_rate, shipping_free_threshold, store_name, currency')
    .eq('id', 1)
    .maybeSingle();

  if (error) throw error;

  return {
    shipping_flat_rate: Number(data?.shipping_flat_rate) || 0,
    shipping_free_threshold:
      data?.shipping_free_threshold == null || data?.shipping_free_threshold === ''
        ? null
        : Number(data.shipping_free_threshold),
        store_name: data?.store_name || 'Laurenti Apparel',
    currency: data?.currency || 'USD',
  };
}

export function calculateShipping(subtotal, settings) {
  const rate = Number(settings?.shipping_flat_rate) || 0;
  const threshold = settings?.shipping_free_threshold;
  if (threshold != null && !Number.isNaN(threshold) && subtotal >= threshold) {
    return 0;
  }
  return Math.max(0, rate);
}
